
export const footer = {
  'footer.allRightsReserved': 'All rights reserved.',
} as const;
